//React
import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
//Assets
import plus from "../../../assets/svgs/plus.svg";
//CSS
import "./index.scss";

function AddAudience({ tag = "Blank" }) {
	return (
		<div className="add-audience">
			<Link
				type="button"
				to="/audience-builder-v2"
				className="audience-new"
			>
				<img
					src={plus}
					alt="Add Audience"
				/>
				<span className="p3 strong">Create a custom audience</span>
			</Link>
			<p className="tag p4">{tag}</p>
		</div>
	);
}

AddAudience.propTypes = {
	tag: PropTypes.string,
};

export default AddAudience;
